namespace Background {

	export let stage: PIXI.Container = null;
	export let tex: PIXI.RenderTexture = null;
	export let spr: PIXI.Sprite = null;

	export let clearMode = 20;

	// new (PIXI as any).BlendMode(
	// 	0, WebGLRenderingContext.ONE_MINUS_SRC_ALPHA,
	// 	0, WebGLRenderingContext.ONE_MINUS_SRC_ALPHA
	// );

	export function init() {
		MainLoop.onEnterFrame.addListener(update, 1);

		stage = new PIXI.Container();

		App.stage.addChild(new PIXI.Sprite(Assets.bg));

		tex = PIXI.RenderTexture.create(App.screen.width, App.screen.height);
		spr = new PIXI.Sprite(tex);
		App.stage.addChild(spr);

		(App.renderer.state as any).blendModes[20] = [0, WebGLRenderingContext.ONE_MINUS_SRC_ALPHA];
	}

	export function update() {
		App.renderer.render(stage, tex, false);
		stage.removeChildren();
	}
}
